<template>
  <p class="paragraph" :class="rootClasses">
    <slot />
  </p>
</template>

<script>
export default {
  name: 'Paragraph',

  props: {
    color: {
      type: String,
      default: 'font-1',
      validator: (value) => {
        return ['font-i', 'font-1', 'font-2', 'font-3', 'primary', 'secondary'].includes(value);
      },
    },
    size: {
      type: String,
      default: 'small',
      validator: (value) => {
        return ['small', 'medium', 'large'].includes(value);
      },
    },
  },

  computed: {
    rootClasses: function () {
      return {
        'is-tiny': this.size === 'tiny',
        'is-small': this.size === 'small',
        'is-medium': this.size === 'medium',
        'is-large': this.size === 'large',
        'is-font-i': this.color === 'font-i',
        'is-font-1': this.color === 'font-1',
        'is-font-2': this.color === 'font-2',
        'is-font-3': this.color === 'font-3',
        'is-primary': this.color === 'primary',
        'is-secondary': this.color === 'secondary',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  line-height: 1.5;
  color: $--color--font-1;

  &.is-tiny {
    @include font-size(16px);
  }
  &.is-small {
    @include font-size(20px);
  }
  &.is-medium {
    @include font-size(23px);
  }
  &.is-large {
    @include font-size(32px);
    font-weight: 600;
  }

  &.is-font-i {
    color: $--color--font-i;
  }
  &.is-font-1 {
    color: $--color--font-1;
  }
  &.is-font-2 {
    color: $--color--font-2;
  }
  &.is-font-3 {
    color: $--color--font-3;
  }
  &.is-primary {
    color: $--color--primary;
  }
  &.is-secondary {
    color: $--color--secondary;
  }
}
</style>
